module.exports = __webpack_public_path__ + "static/media/logo143.32e8300f.png";